export default {
  data() {
    return {
      searchSchema: [
        {
          label: '评分卡名称',
          type: 'input',
          itemName: 'cardName',
          allowClear: true,
        },
      ],
      searchForm: {
        cardName: '',
      },
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      tableData: [],

      tableColumns: [
        {
          fixed: 'left',
          title: '序号',
          width: 60,
          align: 'center',
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
        },
        {
          title: '条件',
          width: 120,
          dataIndex: 'typeName',
          align: 'center',
        },
        {
          title: '条件业务',
          width: 120,
          dataIndex: 'name',
          align: 'center',
        },
        {
          title: '条件限制',
          width: 120,
          dataIndex: 'lessType',
          align: 'center',
        },
        {
          title: '额度(RMB)',
          width: 100,
          dataIndex: 'amount',
          align: 'center',
        },
        {
          title: '账期(天)',
          width: 100,
          dataIndex: 'term',
          align: 'center',
        },
        {
          title: '编辑时间',
          width: 160,
          dataIndex: 'createTime',
          align: 'center',
        },
        {
          title: '编辑人名称',
          width: 160,
          dataIndex: 'userName',
          align: 'center',
        },
        {
          title: '操作',
          width: 200,
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  methods: {
    // 查询
    handleSearch(data) {
      this.searchForm = { ...this.searchForm, ...data }
      this.pageData.current = 1
      this._getTableData()
    },
    // 点击分页按钮
    handleClickPage({ current, pageSize }) {
      this.pageData = { ...this.pageData, current, pageSize }
      this._getTableData()
    },
  },
}
